<template>
	<div class="ms-list-row-item"
		v-on:click= "onClick"
	>
		<template v-if="item.isProgress">
			<div color="success" class="mb-list-row-item-left" />
		</template>
		<template v-else>
			<div color="error" class="mb-list-row-item-left" />
		</template>
		<div class="ms-list-row-item-content">
			<div style="width: 100%;">
				<div class="name">{{ item.name }}</div>
				<div class="schedule_title">{{ schedule.title }}<br></div>
				<span class="blue--text ms-list-row-item-period">{{textBeginDate}}～{{textEndDate}}</span>
			</div>
		</div>
		<div class="ms-list-row-item-progress-rate">{{schedule.progress_rate}}%</div>
		<div class="ms-list-row-item-photo" 
			v-if="use_talkroom" 
			v-on:click="onClickShowPhotoAlbum"
		>
			<v-icon>camera_alt</v-icon>
		</div>
	</div>
</template>
<script>
import APIClient from '../classes/APIClient';

const strftime = require('strftime');
export default {
	name: 'MSScheduleListRow',
	props: [
		"item",
		"schedule",
		"use_talkroom",
	],
	data () {
		return {
			api: new APIClient(this.$store),
		}
	},
	methods: {
		onClick: function() {
			this.$emit("progress-rate-setting", {
				schedule: this.schedule,
			});
		},
		onClickShowPhotoAlbum: async function(e) {
			this.api.searchTalkRoom(this.schedule.project_code, this.schedule.member_code, this.schedule.code)
				.then((response) => {
					if (response.status == 200) {
						this.enterTalkRoom(this.schedule.member_code, response.data.room_id);
					} else if (response.status == 204) {
						this.api.createTalkRoom(this.schedule.project_code, this.schedule.member_code, this.schedule.code)
							.then((res) => {
								this.enterTalkRoom(this.schedule.member_code, res.data.room_id);
							})
							.catch(() => {
								this.logout();
							});
					}
				})
				.catch(() => {
					this.logout();
				});
			e.stopPropagation();
		},
		enterTalkRoom: function(member_id, talkroom_id) {
			this.$router.push({
				name: 'MSTalkRoom', 
				params: { 
					'contractor_id': this.$route.params.contractor_id, 
					'id': member_id,
					'talkroom_id': talkroom_id,
				},
			});
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
	},
	computed: {
		textBeginDate: function() {
			let beginDate = this.schedule.beginDate;
			return strftime('%Y年%m月%d日', beginDate);
		},
		textEndDate: function() {
			let endDate = this.schedule.endDate;
			return strftime('%Y年%m月%d日', endDate);
		},
	},
};
</script>
<style>
	.mb-list-row-item-left{
		width: 16px;
	}
	
	.ms-list-row-item-period{
		font-size: .75em;
	}
	
	.ms-list-row-item-progress-rate, .ms-list-row-item-photo{
		font-size: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-right: 14px;
	}
	
	.ms-list-row-item {
		background-color: #fefefe;
		cursor: pointer;
		position: relative;
		flex: 1 1 auto;
		overflow: hidden;
		width: 100%;
		height: 65px;
		border-top: 1px solid #ffffff;
		display: flex;
	}

	.ms-list-row-item-content {
		padding: .25em;
		padding-left: 0.5em;
		width: 100%;
	}
	.ms-list-row-item .ms-list-row-item-content .name {
		word-wrap: normal;
		overflow: hidden;
		height: 1.5em;
	}
	.ms-list-row-item .ms-list-row-item-content .schedule_title {
		word-wrap: normal;
		overflow: hidden;
		height: 1.5em;
		font-size: 12px;
	}

</style>
